import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { IMAGES } from "@/data/content";
import { useContent } from "@/context/ContentContext";
import { Reveal } from "@/components/site/Reveal";

export const About = () => {
  const CONTENT = useContent();
  const ABOUT = CONTENT.about || { intro: "", paragraphs: [], areas: [] };
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [40, -40]);

  return (
    <section id="sobre" ref={ref} className="py-24 lg:py-36">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-14 lg:gap-20 items-start">
        <div className="lg:col-span-5 lg:sticky lg:top-28">
          <motion.div style={{ y }} className="relative overflow-hidden rounded-[2rem] aspect-[4/5] bg-rose-50">
            <img src={IMAGES.about} alt={CONTENT.fullName} className="w-full h-full object-cover object-top" />
          </motion.div>
        </div>

        <div className="lg:col-span-7">
          <Reveal>
            <span className="text-xs uppercase tracking-[0.25em] text-rose-800">Sobre</span>
            <h2 className="font-display font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.02] text-stone-900 mt-5">
              {ABOUT.intro}
            </h2>
          </Reveal>

          <div className="mt-8 space-y-5 max-w-xl">
            {ABOUT.paragraphs.map((p, i) => (
              <Reveal key={i} delay={0.1 + i * 0.08}>
                <p className="text-stone-600 leading-relaxed">{p}</p>
              </Reveal>
            ))}
          </div>

          <Reveal delay={0.2}>
            <h3 className="mt-12 mb-6 text-sm uppercase tracking-[0.2em] text-stone-400">
              Áreas de intervenção
            </h3>
          </Reveal>
          <div className="grid sm:grid-cols-2 gap-x-8 gap-y-4">
            {(ABOUT.areas || []).map((a, i) => (
              <Reveal key={i} delay={0.05 * i}>
                <div className="flex gap-3 items-start">
                  <span className="mt-2 h-1.5 w-1.5 rounded-full bg-rose-500 shrink-0" />
                  <span className="text-sm text-stone-700 leading-snug">{a}</span>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
